import React, { useEffect, useState } from "react";
import moment from "moment";
import { getUserRecentActivities } from "../../UrlCrud";
import { ReportEmpty, ReportError, ReportLoading } from "./DashboardStates";

/**
 * Redesigned Recent Activity feed - reuses the exact same endpoint the old
 * ListsWidget9 used (GET /v2/activities/:userId via getUserRecentActivities,
 * frontend/src/app/UrlCrud.js), just re-presented: the activity message is
 * now the primary line, the timestamp is small/secondary (previously the
 * timestamp was rendered in a wide bold "timeline-label" column that
 * visually competed with the message). Relative time ("5 minutes ago")
 * instead of a bare clock time, and a subtle dot instead of a wide
 * timeline rail - more compact, no longer "narrow and vertically
 * stretched". Scrolls only past a generous max-height (see dashboard.scss)
 * rather than growing the whole page unboundedly.
 */
export default function RecentActivity({ userId }) {
  const [activities, setActivities] = useState(null);
  const [error, setError] = useState(null);

  const fetchActivities = () => {
    if (!userId) return;
    setError(null);
    getUserRecentActivities(userId)
      .then(({ data }) => setActivities(data || []))
      .catch(() => setError("Couldn't load recent activity."));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchActivities, [userId]);

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <h2 className="dashboard-panel__title">Recent activity</h2>
      </div>

      {error && <ReportError message={error} onRetry={fetchActivities} />}
      {!error && activities === null && <ReportLoading />}
      {!error && activities !== null && activities.length === 0 && (
        <ReportEmpty message="No recent activity yet." />
      )}
      {!error && activities !== null && activities.length > 0 && (
        <ul className="activity-feed">
          {activities.map(item => (
            <li className="activity-feed__item" key={item._id}>
              <span className="activity-feed__dot" aria-hidden="true" />
              <div className="activity-feed__body">
                <div className="activity-feed__message">{item.description || item.label}</div>
                <div className="activity-feed__time">{moment(item.createdAt).fromNow()}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
